import { Box, CircularProgress } from "@mui/material";

import { ScreenCenter } from "../screen-center/screen-center";

export const SpinnerCenter = ({
  msg,
  minHeight = `90vh`,
  size = 30,
  fontSize,
}: {
  msg?: string;
  minHeight?: string;
  size?: number;
  fontSize?: number;
}): JSX.Element => {
  return (
    <ScreenCenter minHeight={minHeight}>
      <CircularProgress size={size} />
      {msg && (
        <>
          <Box width={20} />
          <span style={{ fontSize: fontSize }}>{msg}</span>
        </>
      )}
    </ScreenCenter>
  );
};
